import { Component, Input, EventEmitter, Output, HostListener, DoCheck } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'up-feature-list-filters',
  templateUrl: './feature-list-filters.component.html',
  styleUrls: ['./feature-list-filters.component.scss']
})
export class FeatureListFiltersComponent implements DoCheck {
  departments$: Observable<any>;
  units$: Observable<any>;
  roles$: Observable<any>;

  @Input() departments: any;
  @Input() units: any;
  @Input() roles: any;
  @Input() collaboratorStatuses: any;
  @Input() status: any;
  @Input() acc: string;
  @Input() completed: string;
  @Input() archived: string;
  @Input() pendingCompany: string;
  @Input() isCollaboratorModule = false;
  @Input() isRescueScreen = false;
  @Input() eventTarget: string;
  @Input() theme: string;
  @Output() params = new EventEmitter();

  filterUnits = [];
  filterDepartments = [];
  filterRoles = [];
  filterStatus = null;
  filterStates = [];
  menuExport = false;

  documents = {
    deliveryPending: false,
    validationPending: false,
    esocialValidationPending: false,
    deliveryCompleted: false,
    validationCompleted: false,
    esocialValidationCompleted: false,
    deliveryCorrection: false,
    esocialError: false
  };
  medicalExam = {
    schedulePending: false,
    deliveryPending: false,
    validationPending: false,
    scheduleCompleted: false,
    deliveryCompleted: false,
    validationCompleted: false,
    deliveryError: false
  };
  bankAccount = {
    deliveryPending: false,
    receiptPending: false,
    validationPending: false,
    deliveryCompleted: false,
    receiptCompleted: false,
    validationCompleted: false,
    receiptError: false
  };
  documentSigned = {
    deliveryPending: false,
    deliveryCompleted: false
  };

  @HostListener('document:click', ['$event'])
  clickedOutside() {
    this.menuExport = false;
  }

  ngDoCheck(): void {
    this.departments$ = this.departments;
    this.roles$ = this.roles;
    this.units$ = this.units;
  }

  clickInside(e: any): void {
    e.preventDefault();
    e.stopPropagation();
  }

  filterResults() {
    return {
      units: this.filterUnits,
      departments: this.filterDepartments,
      roles: this.filterRoles,
      positions: [],
      account: this.acc,
      status: {
        archived: this.archived,
        completed: this.completed,
        pendingCompany: this.pendingCompany,
        application: { pending: false, completed: false },
        documents: this.documents,
        medicalExam: this.medicalExam,
        bankAccount: this.bankAccount,
        documentSigned: this.documentSigned
      },
      pagination: { skip: 0, limit: 10 },
      sort: {
        objectCreated: -1
      },
      states: this.filterStates
    };
  }

  downloadFile(data: any): void {
    const blob = new Blob([data], { type: 'application/excel' });
    const link = document.createElement('a');
    link.target = '_blank';
    link.href = window.URL.createObjectURL(blob);
    link.download = `${this.acc}-${Date.now()}`;
    link.click();
    this.menuExport = false;
  }

  toggleDropDown(): void {
    this.menuExport = !this.menuExport;
  }

  export(): void {
    //   this.dialogExport = this.dialog.open(ExportComponent, {
    //     data: {
    //       type: 'summary',
    //       files: ['csv', 'fpw', 'success-person', 'success-admission', 'success-dependents'],
    //       data: {
    //         account: this.acc,
    //         units: this.filterUnits,
    //         departments: this.filterDepartments,
    //         roles: this.filterRoles,
    //         status: {
    //           archived: this.archived,
    //           completed: this.completed,
    //           pendingCompany: this.pendingCompany,
    //           application: { pending: false, completed: false },
    //           documents: this.documents,
    //           medicalExam: this.medicalExam,
    //           bankAccount: this.bankAccount,
    //           documentSigned: this.documentSigned
    //         },
    //         sort: {
    //           objectCreated: -1
    //         }
    //       }
    //     }
    //   });
  }

  exportSummary(): void {
    //   this.dialogExport = this.dialog.open(ExportComponent, {
    //     data: {
    //       type: 'summary',
    //       header: 'Exportar listagem de candidatos',
    //       files: ['csv'],
    //       data: {
    //         account: this.acc,
    //         units: this.filterUnits,
    //         departments: this.filterDepartments,
    //         roles: this.filterRoles,
    //         status: {
    //           archived: this.archived,
    //           completed: this.completed,
    //           pendingCompany: this.pendingCompany,
    //           application: { pending: false, completed: false },
    //           documents: this.documents,
    //           medicalExam: this.medicalExam,
    //           bankAccount: this.bankAccount,
    //           documentSigned: this.documentSigned
    //         },
    //         sort: {
    //           objectCreated: -1
    //         }
    //       }
    //     }
    //   });
  }

  exportData(): void {
    //   this.dialogExport = this.dialog.open(ExportComponent, {
    //     data: {
    //       type: 'data',
    //       header: 'Exportar informações dos candidatos para folha',
    //       files: [
    //         'apdata-candidate',
    //         'apdata-employee',
    //         'csv',
    //         'csv-ec',
    //         'csv-apdata-employee',
    //         'csv-apdata-dependents',
    //         'csv-peoplesoft',
    //         'csv-sharp',
    //         'csv-senior',
    //         'csv-senior-admission',
    //         'csv-senior-person',
    //         'fpw-dependents',
    //         'fpw-employee',
    //         'fpw-position',
    //         'success-person',
    //         'success-admission',
    //         'success-dependents'
    //       ],
    //       data: {
    //         account: this.acc,
    //         units: this.filterUnits,
    //         departments: this.filterDepartments,
    //         roles: this.filterRoles,
    //         status: {
    //           archived: this.archived,
    //           completed: this.completed,
    //           pendingCompany: this.pendingCompany,
    //           application: { pending: false, completed: false },
    //           documents: this.documents,
    //           medicalExam: this.medicalExam,
    //           bankAccount: this.bankAccount,
    //           documentSigned: this.documentSigned
    //         },
    //         sort: {
    //           objectCreated: -1
    //         }
    //       }
    //     }
    //   });
  }

  selectCollaboratorStatuses(value: any): void {
    this.filterStates = value;
    this.params.emit(this.filterResults());
  }

  selectDepartments(value: any): void {
    this.filterDepartments = value;
    this.params.emit(this.filterResults());
  }

  selectRoles(value: any): void {
    this.filterRoles = value;
    this.params.emit(this.filterResults());
  }

  selectFilter(value: any): void {
    this.documents = value.documents;
    this.medicalExam = value.medicalExam;
    this.bankAccount = value.bankAccount;
    this.documentSigned = value.documentSigned;
    this.params.emit(this.filterResults());
  }

  selectUnits(value: any): void {
    this.filterUnits = value;
    this.params.emit(this.filterResults());
  }
}
